export default __webpack_public_path__ + "static/char-s-06-cht-f4ebd64822430b90d70d3ccae0e4a4fb.png";